import { createSubsetSelector } from 'webui/utils/selectors';
export const select_device_gps_fields = createSubsetSelector([
    'iconState',
    'last_connect_time',
    'last_receive_time',
]);
